exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image[data-v-2378b3b2] {\n  position: relative;\n  width: 100%;\n  height: 0;\n  padding-bottom: 100%;\n  overflow: hidden;\n  mix-blend-mode: multiply;\n}\n.image__thumb[data-v-2378b3b2] {\n    max-width: 100%;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: auto;\n    height: auto;\n    -webkit-transform: translate3d(-50%, -50%, 0);\n    transform: translate3d(-50%, -50%, 0);\n    pointer-events: none;\n}\n", ""]);

// exports
